import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { AppConstants } from "../../app.constants";
import { Observable, of } from "rxjs";
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorHandlerService } from "src/app/core/services/error-handler.service";

@Injectable({
  providedIn: 'root'
})
export class UploadtoliveService {

  constructor(private http: HttpClient, private router: Router, private errorHandlerService: ErrorHandlerService) { }

  uploadToLiveDb(brand: string, nda: string, email: string): Observable<any> {
    const data = { brand: brand, nda: nda, user_email: email };
    return this.http.post(`${AppConstants.API_ENDPOINT1}${AppConstants.API.UPLOAD_TO_LIVE_DB.UPLOAD_TO_LIVE}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

}
